document.addEventListener('DOMContentLoaded', function () {
    const toggle = document.querySelector('.swatches-toggle__cta');
    const colors = document.querySelector('.ms-product__colors');

    toggle.addEventListener('click', function () {
        colors.classList.toggle('is-expanded');

        toggle.textContent = colors.classList.contains('is-expanded')
        ? 'SEE LESS'
        : 'SEE MORE';
    });
});